// extracted by mini-css-extract-plugin
export default {"maincontainer":"Index_maincontainer__KRLff"};